import type { ValueOf } from '@vy/utils';

export const ARROW_ICON_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export type ArrowIconDirection = ValueOf<typeof ARROW_ICON_DIRECTIONS>;
